import * as React from 'react';

import { api } from '../../environment';
import {useParams } from 'react-router-dom';
import Form from '../../components/formElements/Form';
import { isEmail, isEmpty } from '../../components/formElements/validators';
import { makeFormControls } from '../../components/formElements/util';
import Table from '../../components/table/Table';
import Select from '../../components/formElements/Select';
import Modal from '../../components/modal/Modal';
import { abort } from 'process';

export default function ApplicationView(){

    const {id} = useParams()

    

    const [pricingOptions, setPricingOptions] = React.useState([{value:"1", text:"Rana"},{value:"2", text:"Srednja"}, {value:"3", text:"Kasna"}, {value:"4", text:"Posebna"}, {value:'5', text:'Bez kotizacije'}, {value:'6', text:'Članovi Organizacijskog/Programskog odbora'}])

    const [departureDisabled, setDepartureDisabled] = React.useState(true)
    const [departureDates, setDepartureDates] = React.useState([])
    const [peopleNumber, setPeopleNumber] = React.useState(0)
    const [hotelVisible, setHotelVisible] = React.useState(false);
    const [paymentNeeded, setPaymentNeeded] = React.useState(true);
    const [statusData, setStatusData] = React.useState({status:{value:"", validity:{valid:true}}});
    

    const setNecessary = (formControls, setFormControls, bool) => {
        let formControlsCopy = structuredClone(formControls);
        for(let key in formControlsCopy){
            if(formControlsCopy[key].validity.formNecessary!=null){
                formControlsCopy[key].value = "";
                formControlsCopy[key].validity.formNecessary = bool;
                formControlsCopy[key].validity.valid= !formControlsCopy[key].validity.necessary;
                if(!bool){
                    formControlsCopy[key].validity.warning="";
                }
            }
        }
        setFormControls(formControlsCopy);
    }

    const makePricingArray = (value) =>{
        let pricings = [{value:"1", text:"Rana"},{value:"2", text:"Srednja"}, {value:"3", text:"Kasna"}, {value:"4", text:"Posebna"}, {value:'5', text:'Bez kotizacije'}, {value:'6', text:'Članovi Organizacijskog/Programskog odbora'}];
        let prices = [180,280,380,80, 0, 0]

        if(value=="6"){
            pricings = [{value:"1", text:"Rana"},{value:"2", text:"Srednja"}, {value:"3", text:"Kasna"}, {value:"4", text:"Posebna"}, {value:'5', text:'Bez kotizacije'}]
            prices = [280,380, 480, 180, 0]
        }

        return pricings.map((pricing, index)=>{
            return {value: pricing.value, text: pricing.text + ' - ' + prices[index].toString() + " €" }
        })

    }

    const makeDepartureDates = (value)=>{
        const departureDates = ['6.11.2024', '7.11.2024', '8.11.2024'];

        return departureDates.slice(Number(value)-6, departureDates.length).map((date, index)=>{
            return {value:date[0], text:date}
        })
    }

    

    const participantFormData=[
        {name:'first_name', type:'text', label:'ime', necessary:true, validators:[isEmpty], layoutStyle:{flex:'1 1 45%'}},
        {name:'last_name', type:'text', label:'prezime', necessary:true, validators:[isEmpty], layoutStyle:{flex:'1 1 45%'}},
        {name:'oib', type:'text', label:'oib', necessary:true, validators:[isEmpty], layoutStyle:{flex:'1 1 45%'}},
        {name:'address', type:'text', label:'adresa', necessary:true, validators:[isEmpty], layoutStyle:{flex:'1 1 45%'}},
        {name:'state', type:'text', label:'država', necessary:true, validators:[isEmpty], layoutStyle:{flex:'1 1 45%'}},
        {name:'city', type:'text', label:'grad', necessary:true, validators:[isEmpty], layoutStyle:{flex:'1 1 45%'}},
        {name:'phone', type:'text', label:'telefon', necessary:false, validators:[isEmpty], layoutStyle:{flex:'1 1 45%'}},
        {name:'mobile', type:'text', label:'mobitel', necessary:false, validators:[isEmpty], layoutStyle:{flex:'1 1 45%'}},
        {name:'e_mail', type:'text', label:'osobna e-mail adresa', necessary:true, validators:[isEmpty, isEmail], layoutStyle:{flex:'1 1 45%'}},
        {name:'hpk_number', type:'select', label:'potrebna prijava sudjelovanja HPK - Hrvatskoj psihološkoj komori', necessary:true, 
                    options: [{value:"1", text: "Da"},
                            {value:"2", text: "Ne"}
                    ],
                    validators: [isEmpty], layoutStyle:{flex:'1 1 45%'}},
        {name:'hpd_membership', type:'select', label:'Stanje članstva HPD', defaultValue:"", necessary:true, 
                    options:[{value:"1", text:"Redovno"}, 
                        {value:"2", text:"Pridruženo"}, 
                        {value:"3", text:"Studentsko"},
                        {value:"4", text:"Umirovljeničko"},
                        {value:"5", text:"Počasno"},
                        {value:"6", text:"Nisam član/članica HPD"}], validators:[isEmpty], layoutStyle:{flex:'1 1 45%'}, 
                    callback:(e)=>{
                        setPricingOptions(makePricingArray(e.target.value))
                        setParticipantFormControls((prevState)=>{
                            prevState['payment_type'] = {value:"", validity:{necessary:true, valid:false}}
        
                            return {...prevState}
                        });
                        
                        
         
                    }},
        {name:'payment_type', type:'select', label:'Vrsta kotizacije', defaultValue:"", necessary:true,
                    options:pricingOptions, callback:(e)=>{
                        if(e.target.value=="6") {
                            setPaymentNeeded(false);
                            setNecessary(paymentProviderFormControls, setPaymentProviderFormControls, false);
                        } else {
                            setPaymentNeeded(true)
                            setNecessary(paymentProviderFormControls, setPaymentProviderFormControls, true);
                        }}, layoutStyle:{flex:'1 1 45%'}, validators:[isEmpty]},

            {name:"status", label:"Status prijave", options:[
                {value:"1", text:"Odobren"},
                {value:"0", text:"Čeka pregled"},
                {value:"-1", text:"Odbijen"}
            ], type:"select", style:{borderColor:"#223d69", color:"#223d69"}}
    ]

    const hotelFormData=[
        {name:'hotel', type:'select', label:'hotel', necessary:true, formNecessary:false, validators:[isEmpty],
            options:[
                {value:'1', text:'Hotel Radisson Blu (5 zvjezdica)'},
                {value:'2', text:'Hotel Amphora(4 zvjezdice)'},
            ], layoutStyle:{flex:'1 1 100%'}},
        {name:'person_count', type:'select', label:'broj osoba u sobi', necessary:true, formNecessary:false, validators:[isEmpty],
            options:[
                {value:'1', text:'1'},
                {value:'2', text:'2'}
            ], layoutStyle:{flex:'1 1 100%'},
        callback:(e)=>{
            setPeopleNumber(Number(e.target.value))
        }}, 
        {name: 'date_arrival', type:'select', label:'datum dolaska', necessary:true, formNecessary:false, validators:[isEmpty],
            options:[
                {value:'5', text:'5.11.2025'},
                {value:'6', text:'6.11.2025'},
                {value:'7', text:'7.11.2025'}
            ], layoutStyle:{flex:'1 1 45%'},
            callback: (e)=>{
                setDepartureDates(makeDepartureDates(e.target.value));
                setDepartureDisabled(false);
            }
        },
        {name: 'date_departure', type:'select', label:'datum odlaska', necessary:true, formNecessary:false, validators:[isEmpty],
            options:[
                {value:'6', text:'6.11.2024'},
                {value:'7', text:'7.11.2024'},
                {value:'8', text:'8.11.2024'}
            ], layoutStyle:{flex:'1 1 45%'},
            
        },
        {name:'name_roommate', type:'text', label:'ime i prezime druge osobe u sobi', necessary:peopleNumber==2, validators:[isEmpty], formNecessary:false, layoutStyle:{flex:'1 2 45%'}, hidden:peopleNumber<2},
        {name:'note', type:'textarea', label:'napomena', necessary:false, formNecessary:false, layoutStyle:{flex:'1 1 100%'}},
    ]



    const paymentProviderFormData=[
        {name:'name', type:'text', label:'naziv platitelja', necessary:true, validators:[isEmpty], layoutStyle:{flex:'1 1 45%'}},
        {name:'address', type:'text', label:'adresa platitelja', necessary:true, validators:[isEmpty], layoutStyle:{flex:'1 1 45%'}},
        {name:'oib', type:'text', label:'oib platitelja', necessary:true, validators:[isEmpty], layoutStyle:{flex:'1 1 45%'}},
        {name:'email', type:'text', label:'e-mail adresa platitelja', necessary:true, validators:[isEmpty, isEmail], layoutStyle:{flex:'1 1 45%'}},
        {name:'payment_way', type:'select', label:'način plaćanja', necessary:true, validators:[isEmpty],
            options:[
                {value:'1', text:'Bankovna transakcija'},
                {value:'2', text:'Kreditna kartica'}
            ], layoutStyle:{flex:'1 1 100%'}}
    ]

    const [participantFormControls, setParticipantFormControls] = React.useState(makeFormControls(participantFormData));
    const [hotelFormControls, setHotelFormControls] = React.useState(makeFormControls(hotelFormData));
    const [paymentProviderFormControls, setPaymentProviderFormControls] = React.useState(makeFormControls(paymentProviderFormData));

    const getData = () => {
        let call = fetch(api+"/get_participant/"+id,{
            method: "POST",
            body:JSON.stringify({
                token:localStorage.getItem('site')
            })
            })
            try{
        return call.then(response=>response.json())
            } catch(err){
                console.log(err);
                return {}
            }
    }

    React.useEffect(()=>{
        getData().then((data)=>{
            let booking = data.booking;
            let payment = data.payment;
            let participantValues = structuredClone(participantFormControls);
            let bookingValues = structuredClone(hotelFormControls); 
            let paymentValues=structuredClone(paymentProviderFormControls);
            participantValues.needBooking = true;
            participantValues.needPayment = true;
            for(let key in data){
                if(key!='booking' && key!='payment_provider'&&participantValues[key]!=undefined){
                    participantValues[key].value=data[key]
                }
            }
            for(let key in booking){
                if(bookingValues[key]!=undefined) bookingValues[key].value = booking[key]
            }

            for (let key in payment){
                if(paymentValues[key]!=undefined) paymentValues[key].value = payment[key];
            }
            if(booking==null){
                console.log("BOOKING")
                participantValues.needBooking=false;
            }
            if(payment==null){
                participantValues.needPayment=false;
            }
            setParticipantFormControls(participantValues);
            setHotelFormControls(bookingValues);
            setPaymentProviderFormControls(paymentValues);
            setStatusData({status:{value:participantFormControls.status.value, validity:{valid:true}}});
            setPeopleNumber(hotelFormControls.person_count);
        })
        
    }, [])

    const pricingTableHeader = [
        {name:"order", label:"#"},
        {name:"description", label:"opis"},
        {name:"price", label:"cijena"}
    ]

    const makePaymentDescription = (isMember, paymentType) => {
        if(paymentType=="6"){
            return "Kotizacija za članove Organizacijskog/Programskog odbora"
        }
        if(paymentType=="5"){
            return "Bez kotizacije"
        }
        const pricings = ['Rana', 'Srednja', 'Kasna', 'Posebna'];
        return isMember!=""&&paymentType!=""&&paymentType!="5"?`${pricings[Number(paymentType)-1]} kotizacija ${isMember!="6"?"za članove HPD-a":""}`:"";
    }

    const makeHotelPriceDescription = () => {
        let number_nights = Number(hotelFormControls['date_departure'].value)-Number(hotelFormControls['date_arrival'].value)
        let show = hotelFormControls['person_count'].value != "" && number_nights != 0;
        
        if(participantFormControls['payment_type'].value=="6"){
            return show?"Cijena boravka za članove Organizacijskog/Programskog odbora":""
        }
       
        return show?`Cijena boravka (${hotelFormControls['person_count'].value=="1"?"jedna osoba":"dvije osobe"}) za ${number_nights==1?"jedno noćenje":number_nights==2?"dva noćenja":'tri noćenja'} na bazi ${hotelFormControls['hotel'].value=="1"?"pansiona s doručkom i ručkom.":"noćenja s doručkom."}`:""
    }
    
    const makePaymentPrice = (isMember, paymentType)=>{
        let prices = [180,280,380,80, 0, 0]
        
        if(isMember=="6"){
            prices = [280,380, 480, 180, 0, 0]
        }

        return isMember!=""&&paymentType!=""&&paymentType!="5"?prices[Number(paymentType)-1]:0
    }


const computeHotelpricing = (peopleNumber, hotel, table=false) => {
    const prices = {
        "" : [],
        "1": [155, 100],
        "2": [215, 115]
    }
    if(table){
        return prices[peopleNumber][Number(hotel)-1]
    }
    if(peopleNumber!=""&&hotel!=""){
        if(participantFormControls['payment_type'].value=="6"){
            return ""
        }
        return prices[peopleNumber][Number(hotel)-1]
    } else return ""
    
}

    const sumPricing = () => {
        return (Number(hotelFormControls['date_departure'].value)-Number(hotelFormControls['date_arrival'].value))*computeHotelpricing(hotelFormControls['person_count'].value, hotelFormControls['hotel'].value)+makePaymentPrice(participantFormControls['hpd_membership'].value, participantFormControls['payment_type'].value);
    }

    const pricingTableRows = [
        {order: "1.", description:makePaymentDescription(participantFormControls['hpd_membership'].value,participantFormControls['payment_type'].value), 
        price:makePaymentPrice(participantFormControls['hpd_membership'].value,participantFormControls['payment_type'].value).toString()+'.00 €'},
        {order: "2.", description:makeHotelPriceDescription(), price:`${computeHotelpricing(hotelFormControls['person_count'].value, hotelFormControls['hotel'].value)*(hotelFormControls['date_departure'].value!=""?Number(hotelFormControls['date_departure'].value)-Number(hotelFormControls['date_arrival'].value):0)}.00 €`},
        {order: "", description:"", price:`total: ${sumPricing().toString()}.00 €`}
    ]

    const toggleNecessary = (formControls) => {
        let formControlsCopy = structuredClone(formControls);
        for(let key in formControlsCopy){
            if(formControlsCopy[key].validity.formNecessary!=null){
                formControlsCopy[key].value = "";
                formControlsCopy[key].validity.formNecessary = !formControlsCopy[key].validity.formNecessary;
            }
        }
        setHotelFormControls(formControlsCopy);
    }

    const paymentPricingHeader = [
        {name:"payment_type", label:"", width:"25%"},
        {name:"hpd_members", label:"Članovi HPD-a*", width:"45%"},
        {name:"rest", label:"Ostali", width:"20%"}
    ]

    const paymentPricingBody = [
        {payment_type:"Rana (do 31.07.2024.)", hpd_members:"180.00 €", rest:"280.00 €"},
        {payment_type:"Srednja (od 1.8.2024. do 13.10.2024.)", hpd_members:"280.00 €", rest:"380.00 €"},
        {payment_type:"Kasna (od 14.10.2024. do 5.11.2024)", hpd_members:"380.00 €", rest:"480.00 €"},
        {payment_type:"Posebna**", hpd_members:"80.00 €", rest:"180.00 €"}
    ]

    const [modalHidden, setModalHidden] = React.useState(true);

    const handleUpdateStatus = () =>{
        let call = fetch(api+"/update_participant",{
            method: "POST",
            body:JSON.stringify({
                token:localStorage.getItem('site'),
                participant: {id:id, ...participantFormControls}
            })
            })
    }

    return (
        <>
        <h1 style={{marginBottom:"2rem"}}>Pregled prijave</h1>
        <div>
            <h2>Osobni podatci</h2>
            <div className="flex-row" style={{flexWrap:"wrap", gap:"1.2rem"}}>
            <Form formData={participantFormData} formControls={participantFormControls} setFormControls={setParticipantFormControls}/>
            </div>
            <h2>Podatci o smještaju</h2>
            <div className="flex-row" style={{flexWrap:"wrap", gap:"1.2rem"}}>
                {
                    participantFormControls.needBooking?<Form formData={hotelFormData} formControls={hotelFormControls} setFormControls={setHotelFormControls}/>:<h3 style={{color:"#08d055"}}>Osoba nije prijavila smještaj</h3>
                }
             
            </div>
            <h2>Podatci o platitelju</h2>
            <div className="flex-row" style={{flexWrap:"wrap", gap:"1.2rem"}}>
                    {
                        !participantFormControls.needPayment?<h3 style={{color:"#08d055"}}>Osoba je oslobođena plaćanja kotizacije</h3>:<Form formData={paymentProviderFormData} formControls={paymentProviderFormControls} setFormControls={setPaymentProviderFormControls}/>
                    }
                    
           
            </div>
            <div className="table-wrap">
                    <h2 className="form-subtitle">Izračun cijene sudjelovanja</h2>
                    <Table header={pricingTableHeader} dataSource={pricingTableRows}/>
                </div>
                <button className="modal-button" style={{margin:"2rem"}} onClick={()=>{handleUpdateStatus();setModalHidden(false);}}>Promijeni status</button>
        </div>
        <Modal hidden={modalHidden} title="Podatci uspješno promijenjeni!" content={<p>Kliknite na "U redu" za povratak na pregled prijave</p>} buttons={[<button className="modal-button" onClick={()=>{setModalHidden(true);window.location.reload();}}>U redu</button>]}/>
        </>
    )
}